import type { SxProps, Theme } from "@mui/material/styles";

export const desktopGrid: SxProps<Theme> = (theme) => ({
  display: { xs: "none", md: "grid" },
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: theme.spacing(1.75),
});

export const mobileTopGrid: SxProps<Theme> = (theme) => ({
  display: { xs: "grid", md: "none" },
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: theme.spacing(1.25),
});

export const mobileMonthlyCard: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  alignItems: "center",
  justifyContent: "space-between",
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 2,
  px: 2,
  py: 1.625,
};

export const mobileMonthlyLabel: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
};

export const mobileMonthlyValue: SxProps<Theme> = {
  fontSize: "0.9375rem",
  fontWeight: 800,
};

export const mobileMonthlyCurrency: SxProps<Theme> = {
  fontSize: "0.625rem",
  fontWeight: 500,
  color: "text.secondary",
};

export const desktopMonthlyCurrency: SxProps<Theme> = {
  fontSize: "0.6875rem",
  fontWeight: 500,
  color: "text.secondary",
};
